import { render, staticRenderFns } from "./User.Menu.InfoNoFeeds.vue?vue&type=template&id=66f9faa1&scoped=true&"
import script from "./User.Menu.InfoNoFeeds.vue?vue&type=script&lang=js&"
export * from "./User.Menu.InfoNoFeeds.vue?vue&type=script&lang=js&"
import style0 from "./User.Menu.InfoNoFeeds.vue?vue&type=style&index=0&id=66f9faa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f9faa1",
  null
  
)

export default component.exports